import { DISMISS_ALERT, SHOW_ALERT } from '../actions/alert'

const state = {
  alert: {
    color: '',
    icon: '',
    message: ''
  }
}
const getters = {
  alert: state => state.alert
}

const mutations = {
  [SHOW_ALERT] (state, alertParams) {
    let {
      message,
      error,
      color = 'primary',
      icon = 'check_circle'
    } = alertParams
    if (error) {
      message = error
      color = 'error'
      icon = 'warning'
    }
    state.alert = {
      color,
      icon,
      message
    }
  },
  [DISMISS_ALERT] (state) {
    state.alert = {
      color: '',
      icon: '',
      message: ''
    }
  }
}

const actions = {
  [SHOW_ALERT] ({ commit }, alertParams) {
    const { timeout = 2000 } = alertParams
    commit(SHOW_ALERT, alertParams)
    setTimeout(() => {
      commit(DISMISS_ALERT)
    }, timeout)
  }
}

export default {
  state,
  getters,
  mutations,
  actions
}
